import { Directive, HostListener, ElementRef, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
	selector: '[currencyFormatter]',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => CurrencyFormatterDirective),
		multi: true
	}]
})
export class CurrencyFormatterDirective implements ControlValueAccessor {

	private onChange: (value: any) => void;
	private onTouched: () => void;

	private _value: number = null;

	constructor(private el: ElementRef<HTMLInputElement>) { }

	// 👉 от модела към екрана
	writeValue(value: any): void {
		if (value === null || value === undefined || value === '') {
			this._value = null;
			this.el.nativeElement.value = '';
			return;
		}

		this._value = Number(value);
		if (isNaN(this._value)) {
			this.el.nativeElement.value = '';
			return;
		}

		this.el.nativeElement.value = this.formatCurrency(this._value);
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	setDisabledState?(isDisabled: boolean): void {
		this.el.nativeElement.disabled = isDisabled;
	}

	// 👉 когато потребителят фокусира полето – показваме чисто число
	@HostListener('focus')
	onFocus() {
		if (this._value !== null && this._value !== undefined) {
			this.el.nativeElement.value = this._value.toString().replace('.', ',');
		}
	}

	// 👉 при промяна (докато пише) – ъпдейтваме _value и модела
	@HostListener('input', ['$event.target.value'])
	onInput(value: string) {
		// махаме интервали, лв и т.н.
		const normalized = value
			.replace(/\s/g, '')
			.replace('€', '')
			.trim()
			.replace(',', '.');

		const num = parseFloat(normalized);
		if (!isNaN(num)) {
			this._value = num;
			if (this.onChange) {
				this.onChange(num);
			}
		} else {
			this._value = null;
			if (this.onChange) {
				this.onChange(null);
			}
		}
	}

	// 👉 при blur – форматираме красиво
	@HostListener('blur')
	onBlur() {
		if (this.onTouched) {
			this.onTouched();
		}

		if (this._value === null || this._value === undefined || isNaN(this._value)) {
			this.el.nativeElement.value = '';
			return;
		}

		this.el.nativeElement.value = this.formatCurrency(this._value);
	}

	private formatCurrency(value: number): string {
		return '€ ' + value.toLocaleString('bg-BG', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
	}
}
